// Market Visit Report Constants

export const MAX_ESCALATION_LIMIT = 5;

export const ESCALATION_OPTIONS = [
  "Category Head",
  "Trade Marketing Manager",
  "Product Manager",
  "Field Marketing Manager",
  "Dealer helpline",
  "WSS helpline",
  "My Pidilite",
  "ZSM",
  "DSOM/SDM",
  "NSOM",
  "NSM",
  "DDM",
];

export const CHARACTER_LIMITS = {
  wssVisited: 255,
  keyObservationWss: 2000,
  darpanDealer: 500,
  dealerVisited: 255,
  issueFacedDealer: 2000,
  deliveryFeedback: 2000,
  schemeComments: 500,
  userVisited: 255,
  keyObsUser: 2000,
  issuesFacedByBank: 2000,
  productQuality: 2000,
  newProductOpportunity: 500,
  productOtherFeedback: 500,
  competitionActivity: 2000,
  competitionProducts: 500,
  urgentEscalation: 2000,
  feedbackOnUserLoyalty: 500,
  feedbackOnUserApp: 500,
  feedbackAtUserMeeting: 500,
  obsFromRedemptionCenter: 500,
  largeImproveAreas: 500,
  miscellaneousSection: 500,
};

/**
 * Helper to check if value is empty
 */
export const isEmpty = (value) => {
  if (value === null || value === undefined || value === "") return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.keys(value).length === 0;
  return false;
};

/**
 * Debounce helper function
 */
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

/**
 * Get current date in YYYY-MM-DD format
 */
export const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * Format date to readable string
 */
export const formatDate = (date) => {
  const d = new Date(date);
  const options = {
    weekday: "short",
    month: "short",
    day: "2-digit",
    year: "numeric",
  };
  return d.toLocaleDateString("en-US", options);
};

/**
 * Separate dates into draft and submitted
 */
export const separateDates = (records) => {
  const draftDates = [];
  const otherDates = [];

  records.forEach((record) => {
    if (record.IsSavedDraft__c === "True") {
      draftDates.push(record.SaveFormDate__c);
    } else {
      otherDates.push(record.SaveFormDate__c);
    }
  });

  return { draftDates, otherDates };
};
